import React from 'react'
import localeData from '../../helpers/login.lang'
import {language} from '../../helpers/login.data'

const locale = localeData[language]
const ProdWarning = () => (
  <div className='prodWarning'>
    <div className='title'>{locale.productionWarningTitle()}</div>
    <div>{locale.productionWarningInfo()}</div>
  </div>
)

export default ProdWarning
